import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { InactivityProvider } from "./context/InactivityContext";

const container = document.getElementById("root");

if (!container) {
  throw new Error(
    "Root container not found. Please make sure your index.html has <div id='root'></div>"
  );
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <InactivityProvider>
        <App />
      </InactivityProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
